import React from 'react';
import { IconButton } from '@blend-ed/blendx-ui';
import { useDarkMode } from '../../hooks/useDarkMode';

const DarkModeToggle = () => {
  const { isDarkMode, toggleDarkMode } = useDarkMode();

  return (
    <IconButton
      variant="ghost-gray"
      icon={isDarkMode ? "sun" : "moon"}
      iconType="line"
      onClick={toggleDarkMode}
      aria-label={isDarkMode ? "Switch to light mode" : "Switch to dark mode"}
    />
  );
};

export default DarkModeToggle;
